import { css } from "@emotion/react";
import { useFormContext } from "react-hook-form";
import { Button, Font } from "@moneyforward/mfx_biz_react_components";
import { color } from "@/styles/theme";
import { EmailFormField } from "@/components/molecules";

type FormValues = {
  email: string;
};

type Props = {
  onSubmit?: ({ email }: FormValues) => void;
};

export const ForgotPasswordSendMailForm = ({ onSubmit }: Props) => {
  const { handleSubmit, formState } = useFormContext();
  return (
    <div css={container}>
      <div css={box}>
        <form onSubmit={handleSubmit(onSubmit)} css={form}>
          <div css={inputWrapper}>
            <EmailFormField name="email" />
          </div>
          <div css={buttonWrapper}>
            <Button type="submit" disabled={formState.isSubmitting}>
              送信
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

const container = css({
  display: "flex",
  justifyContent: "center",
});

const box = css({
  width: "640px",
  minHeight: "197px",
  padding: "40px 24px",
  border: `1px solid ${color.iron}`,
  borderRadius: "2px",
});

const form = css({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
});

const inputWrapper = css({
  flex: 1,
});

const buttonWrapper = css({
  display: "flex",
  justifyContent: "flex-end",
});
